import * as React from 'react';
import { useSelector } from 'react-redux';

import { ErrorComponent } from '../../components/ErrorComponent';
import { selectPage, selectResults } from '../../selectors';
import { EGetFavoriteEntitiesStatus } from '../../types/results';

export const ErrorContainer: React.FC = () => {
  const { deviceType } = useSelector(selectPage);
  const { status } = useSelector(selectResults);

  const handleClick = React.useCallback(() => {
    window.location.reload();
  }, []);

  if (status !== EGetFavoriteEntitiesStatus.Failed) {
    return null;
  }

  return <ErrorComponent deviceType={deviceType} onClick={handleClick} />;
};
